export default function setMileageAllowance(timeplanUnits, originalTPU, updatedValues) {
  if (timeplanUnits.find(tpu => tpu.has('kilometers') && tpu.date === originalTPU.date)) {
    return timeplanUnits.map((tpu) => {
      if (tpu.has('kilometers') && tpu.date === originalTPU.date) {
        return originalTPU.merge(updatedValues);
      }
      return tpu;
    });
  }

  const oldValues = timeplanUnits.filter(tpu => !(tpu.has('kilometers') && tpu.date === originalTPU.date));
  return oldValues.push(originalTPU.merge(updatedValues));
}
